import React, { useState } from 'react';
import { Botao } from '../../egora';
import { EntradaCabeca } from './EntradaMoldura';

/**
 * Os 10 códigos reserva, mostrados uma única vez depois de ligar o segundo fator.
 * `rotuloContinuar` e `aoContinuar` dizem o que acontece depois.
 */
export default function CodigosReserva({ codigos, rotuloContinuar, aoContinuar }) {
  const [copiado, setCopiado] = useState(false);

  const copiar = async () => {
    try {
      await navigator.clipboard?.writeText(codigos.join('\n'));
      setCopiado(true);
    } catch (_) {
      setCopiado(false);
    }
  };

  return (
    <>
      <EntradaCabeca
        icone="key"
        titulo="Guarde os códigos reserva"
        texto="Eles aparecem só agora. Cada um serve uma vez, quando você estiver sem o aplicativo autenticador."
      />
      <ul className="entrada__codigos sj-num" aria-label="Códigos reserva">
        {codigos.map((c) => <li key={c}>{c}</li>)}
      </ul>
      <div className="entrada__acoes">
        <Botao variante="secundario" icone={copiado ? 'check' : 'content_copy'} onClick={copiar}>
          {copiado ? 'Códigos copiados' : 'Copiar códigos'}
        </Botao>
        <Botao onClick={aoContinuar}>{rotuloContinuar}</Botao>
      </div>
    </>
  );
}
